import { APP_NAME, DRAWER_WIDTH } from 'Util/constants'
import { Box, Link } from '@mui/material'
import Typography from '@mui/material/Typography'
import Logo from 'assets/images/waltti-logo-nega.svg'
import { Link as RouterLink } from 'react-router-dom'

export default function MenuBarAppName() {
  return (
    <Box sx={{ minWidth: DRAWER_WIDTH, paddingLeft: '24px' }}>
      <Link
        component={RouterLink}
        to="/"
        sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
      >
        <img src={Logo} alt={`${APP_NAME} Logo`} height="40" style={{ marginRight: '20px' }} />
        <Typography
          variant="h6"
          component="div"
          noWrap
          sx={{ fontFamily: 'Prompt', color: 'white' }}
        >
          {APP_NAME}
        </Typography>
      </Link>
    </Box>
  )
}
